import { RootState, ViewState, Module } from '../types'

import { Find, Patch, Create, Delete } from '@/api/view'
import { View } from '@/types/view'

export const view: Module<ViewState, RootState> = {
  namespaced: true,
  state() {
    return {
      items: [],
    }
  },
  mutations: {
    SET_ITEMS(state, payload) {
      for (const view of payload) {
        view.url = `/v/${view.uid}/${view.slug}`
      }
      state.items = payload
    },
  },
  actions: {
    async get({ commit }) {
      const views = await Find()
      if (Array.isArray(views)) {
        commit('SET_ITEMS', views)
      }
    },

    async patch({ dispatch }, { id, view }) {
      const v = await Patch(id, view)
      await dispatch('get')
      return v
    },

    async createEmptyView({ dispatch }): Promise<View> {
      const v = await Create({ title: 'NEW VIEW', panels: [], isGroup: false })
      await dispatch('get')
      return v
    },
    async createNewGroup({ dispatch }): Promise<View> {
      const v = await Create({ title: 'NEW GROUP', panels: [], isGroup: true })
      await dispatch('get')
      return v
    },

    async delete({ dispatch }, { id }) {
      await Delete(id)
      await dispatch('get')
    },
  },
  getters: {
    items: (state) => state.items,
  },
}
